import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Button, Stack} from 'views/components';
import {ArrowForwardIos} from 'views/icons';
import {WasHelpfulCard, Translate} from 'views/module';

import {primaryButtonSx} from '../../utils/button_styles';

import NextStepsSection from './cards/NextStepsSection';
import WhatHappensCard from './cards/WhatHappensCard';
import WorksCard from './cards/WorksCard';
import SmsOptInCard from './cards/SmsOptInCard';

import backend from 'utils/backend';

const CaregiverMatchingStep = (props) => {
  const {onNext, userRn, clientData} = props;
  const [hasOptedInForSms, setHasOptedInForSms] = React.useState(false);
  const [shouldShowSmsOptInCard, setShouldShowSmsOptInCard] = React.useState(false);

  const clientPhoneNumber = React.useMemo(() => {
    const relationship = clientData?.clientDetail?.relationships?.[userRn];
    return relationship?.contacts?.find((contact) => contact.type === 'Phone')?.detail;
  }, [clientData, userRn]);

  React.useEffect(() => {
    const loadSmsSubscription = async () => {
      if (!clientPhoneNumber) {
        setShouldShowSmsOptInCard(false);
        return;
      }

      try {
        const result = await backend.communication.getSmsSubscription(userRn);
        setShouldShowSmsOptInCard(!(result?.subscription?.subscribed));
      } catch (error) {
        setShouldShowSmsOptInCard(false);
      }
    };

    loadSmsSubscription();
  }, [userRn, clientPhoneNumber]);

  return (
    <Stack sx={{gap: '8px'}}>
      <NextStepsSection />
      <WhatHappensCard />
      <WorksCard />
      {
        shouldShowSmsOptInCard &&
        <SmsOptInCard
          clientPhoneNumber={clientPhoneNumber}
          hasOptedInForSms={hasOptedInForSms}
          setHasOptedInForSms={setHasOptedInForSms}
        />
      }
      <WasHelpfulCard articleTitle="Intake Form | Caregiver Matching | Feedback (Thumbs)" articleRN="RN:ARTICLE-V1-CaregiverMatchingHelpful" />

      <Box sx={{textAlign: 'right', mt: '24px'}}>
        <Button onClick={() => onNext({hasOptedInForSms, clientPhoneNumber})} sx={primaryButtonSx} endIcon={<ArrowForwardIos />}>
          <Translate expression={'caregivermatchingstep.CaregiverMatchingStep.RequestProfilesButton'} />
        </Button>
      </Box>
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  userRn: state.user.userRn,
  clientData: state.clientData,
});

CaregiverMatchingStep.propTypes = {
  onNext: PropTypes.func,
  userRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverMatchingStep));
